// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import type { PaginationSlice, RootState } from "redux/types";

// Defaults
export const initialState: PaginationSlice = {
	isMobile: false,
	pageCount: 0,
	currentPage: 0,
	forcePage: null
};

// Slice
export const paginationSlice = createSlice({
	name: "PAGINATION",
	initialState,
	reducers: {
		setPageCount: (state, action: PayloadAction<number>) => {
			return { ...state, pageCount: action.payload };
		},
		setCurrentPage: (state, action: PayloadAction<number>) => {
			return { ...state, currentPage: action.payload };
		},
		setForcePage: (state, action: PayloadAction<number | undefined>) => {
			return { ...state, forcePage: action.payload };
		},
		setIsMobile: (state, action: PayloadAction<boolean>) => {
			return { ...state, isMobile: action.payload };
		}
	}
});

// Actions
export const { setPageCount, setCurrentPage, setForcePage, setIsMobile } = paginationSlice.actions;

// Selector
export const isMobileSelector = (state: RootState): boolean => state.pagination.isMobile;
export const pageCountSelector = (state: RootState): number => state.pagination.pageCount;
export const currentPageSelector = (state: RootState): number => state.pagination.currentPage;
export const forcePageSelector = (state: RootState): number | undefined | null => state.pagination.forcePage;

// Reducers
export default paginationSlice.reducer;
